export const players = {
  players: "Players",
  createNewPlayer: "สร้างผู้เล่นใหม่",
  createPlayer: "สร้างผู้เล่น",
  playerList: "รายชื่อผู้เล่น",
  search: "ค้นหา",
  advanceFilter: "Advance Filter",
  mobileNumber: "เบอร์โทรศัพท์",
  ipAddress: "IP ADDRESS",
  lastLoginIpAddress: "LAST LOGIN IP ADDRESS",
  activeStatus: "สถานะ",
  date: "วันที่",
  currentBalance: "ยอดเงินคงเหลือ",
  action: "",
  neverLogin: "Never Login",
  dateOfApplication: "Date Of Application",
  bankAccountNumber: "เลขที่บัญชี",
  bankAccountName: "ชื่อบัญชี",
  cancel: "Cancel",
  filter: "Filter",
  username: "Username",
  password: "รหัสผ่าน",
  phoneNumber: "เบอร์โทรศัพท์",
  selectBank: "เลือกธนาคาร",
  affiliateUsername: "Affiliate Username",
  id: "Id",
  firstname: "First Name",
  confirm: "confirm",
  cancel: "cancel",
  confirmActivation: "Confirm Activation",
  confirmUserSespension: "Confirm user Suspension",
};
